import { useEffect } from "react";
import { usePendenciasAtendimento } from "../hooks/use-suporte";

// Título da aba com o número de atendimentos em andamento que têm mensagem nova
// do entregador, como "(3) Planalto Capital". Montado no layout só para quem
// tem a tela de suporte; não desenha nada.
//
// Precisa atualizar com a aba OCULTA (o atendente está em outra aba). Por isso
// não usa o refetchInterval do react-query, que pausa com a aba oculta, nem um
// setInterval comum, que o Chrome estrangula em abas ocultas (até 1x/min). O
// relógio roda num Web Worker, cujos timers não sofrem esse estrangulamento.
const ALERTA_POLL_MS = 10_000;

const prefixo = /^\(\d+\+?\) /;

export const iniciarRelogio = (ms: number, tick: () => void): (() => void) => {
  if (typeof Worker !== "undefined" && typeof URL.createObjectURL === "function") {
    try {
      const url = URL.createObjectURL(new Blob([`setInterval(() => postMessage(0), ${ms});`], { type: "text/javascript" }));
      const worker = new Worker(url);
      worker.onmessage = tick;
      return () => {
        worker.terminate();
        URL.revokeObjectURL(url);
      };
    } catch {
      // cai no setInterval abaixo
    }
  }
  const id = window.setInterval(tick, ms);
  return () => window.clearInterval(id);
};

export function SuporteTituloAlerta({ intervaloMs = ALERTA_POLL_MS }: { intervaloMs?: number }) {
  const { data: pendentes = 0, refetch } = usePendenciasAtendimento();

  useEffect(() => iniciarRelogio(intervaloMs, () => void refetch()), [intervaloMs, refetch]);

  useEffect(() => {
    const base = document.title.replace(prefixo, "");
    document.title = pendentes > 0 ? `(${pendentes > 99 ? "99+" : pendentes}) ${base}` : base;
  }, [pendentes]);

  // Ao sair (logout, tela desligada), devolve o título limpo.
  useEffect(
    () => () => {
      document.title = document.title.replace(prefixo, "");
    },
    [],
  );

  return null;
}
